import api from './apiClient';
import { authAPI } from './authApi';

export const usersAPI = {
  async getProfile() {
    return authAPI.getProfile();
  },

  async updateProfile(userData) {
    try {
      const response = await api.put('/auth/profile', userData);

      const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
      const updatedUser = { ...currentUser, ...response };
      localStorage.setItem('user', JSON.stringify(updatedUser));

      return updatedUser;
    } catch (error) {
      console.error('Error updating profile:', error);
      throw error;
    }
  },
};

export default usersAPI;

